import Card, { CardProps } from '@mui/material/Card';
import Box, { BoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import React from 'react';
import { url } from 'inspector';

interface StyledCardProps extends CardProps {
    selected?: boolean;
    color?: string;
}

interface StyledBoxProps extends BoxProps {
    selected?: boolean;
    color?: string;
    icon?: string;
}

export const ProductCard = styled(Card, {
    shouldForwardProp: (prop) => prop !== 'selected' && prop !== 'color'
})<StyledCardProps>(({ selected, color, theme }) => ({
    backgroundColor: '#FFFFFF',
    border: `1px solid #D9D9D9`,
    boxSizing: 'border-box',
    borderRadius: '10px',
    color: '#202020',
    letterSpacing: '0.07rem',
    minHeight: '100px',
    display: 'flex',

    ...(selected && {
        backgroundColor: `${color}`,
        border: `1px solid ${color}`,
        // boxShadow: `0px 0px 10px 0px ${color}40`,
        color: "#FFF"
    }),
}));

export const ProductName = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'selected' && prop !== 'color' && prop !== "icon"
})<StyledBoxProps>(({ selected, color, icon, theme }) => ({
    // background: `url(${icon ? icon : "https://seuvale-imagens-fixas.s3-sa-east-1.amazonaws.com/Icones-beneficios/SEMIMAGEM.svg"})`,
    // backgroundPosition: 'center',
    // backgroundSize: 'contain',
    // backgroundRepeat: 'no-repeat',
    marginLeft: '10%',
    backgroundColor: color,
    borderRadius: '50%',
    color: '#FFF',
    height: '2em',
    width: '2em',
    textAlign: 'center',
    fontSize: '2.375rem',
    fontWeight: 'normal',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // filter: `brightness(0) saturate(100%) invert(60%)`,

    '& img': {
        height: '60%',
        width: '60%',
    },

    ...(selected && {
        borderRadius: '0',

        '& img': {
            height: '75%',
            width: '75%',
        },
        // filter: `brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(0%) hue-rotate(27deg) brightness(108%) contrast(101%)`
    }),
}));
